import { BACKEND_BASE_URL } from "../config/app.config";
import { httpPost } from "./http.service";
import { aiSocket } from "../config/socketService";

const URL = `${BACKEND_BASE_URL}/api/ai-recommendations`;

const getAIRecommendation = async (payload: any) => {
  try {
    const response = await httpPost(`${URL}`, payload);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

const getSingleStockAIRecommendation = async (payload: any) => {
  try {
    const response = await httpPost(`${URL}`, payload);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

const getStockChatResponse = async (payload: any) => {
  try {
    const response = await httpPost(`${URL}`, payload);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

// Function to get AI recommendations with streaming support
const getAIStreamingResponse = (payload: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let collectedResponse = "";

    aiSocket.emit("ai-analyze-message", payload);

    aiSocket.once("ai-analysis-complete", () => {
      aiSocket.off("ai-analysis-chunk");
      aiSocket.off("ai-analysis-error");
      resolve({
        fullResponse: collectedResponse,
        success: true,
      });
    });

    aiSocket.once("ai-analysis-error", (error) => {
      aiSocket.off("ai-analysis-chunk");
      aiSocket.off("ai-analysis-complete");

      reject(error);
    });
  });
};

// Function to get Stock Assistant Analysis with streaming support
const getStockAssistantStreamingRes = (payload: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let collectedResponse = "";

    aiSocket.emit("stock-assistant-message", payload);

    aiSocket.once("stock-assistant-complete", () => {
      aiSocket.off("stock-assistant-chunk");
      aiSocket.off("stock-assistant-error");
      resolve({
        fullResponse: collectedResponse,
        success: true,
      });
    });

    aiSocket.once("stock-assistant-error", (error) => {
      aiSocket.off("stock-assistant-chunk");
      aiSocket.off("stock-assistant-complete");

      reject(error);
    });
  });
};

export {
  getAIRecommendation,
  getAIStreamingResponse,
  getSingleStockAIRecommendation,
  getStockAssistantStreamingRes,
  getStockChatResponse,
};
